"use strict";
import moment from './momentLocale'
import Decimal from 'decimal.js-light'
import {couchFnReduce} from './couchFnReduce'

Decimal.set({
  precision: 15,
  rounding: Decimal.ROUND_HALF_EVEN
});

var fnSignformatter = function(val, n) {
  if (!isFinite(val)) return "Infinito"
  return new Decimal(val)
    .toSignificantDigits(n || 2)
    .toString()
  ;
}

// https://stackoverflow.com/questions/152975/how-do-i-detect-a-click-outside-an-element 
// adaptado para usar a classe `is-active` ao inves de element.style.display = 'none'
function fnHideOnClickOutside(element) {
  const outsideClickListener = event => {
    if (!element.contains(event.target) && fnIsVisible(element)) { // or use: event.target.closest(selector) === null
      element.classList.remove('is-active')
      removeClickListener()
    }
  }

  const removeClickListener = () => {
    document.removeEventListener('click', outsideClickListener)
  }

  document.addEventListener('click', outsideClickListener)
}

const fnIsVisible = elem => !!elem && !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length ) // source (2018-03-11): https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js 


var fnRegreArray = function (equacaoArr, valorDeTeste) {
  var regre
  if (equacaoArr.length === 1) {
    // Quando a analise e por faixa

    regre = equacaoArr[0].regressaoArr

  } else {
    // Quando a analise e pontual

    //const arrBusca = _.slice(equacaoArr, 0, equacaoArr.length - 1)
    const arrBusca = equacaoArr
    var pontoCond
    pontoCond = _.find(arrBusca, (p) => 
      valorDeTeste <= parseFloat(p.termoADireita))
    ;
    if (!pontoCond) {
      regre = arrBusca[arrBusca.length - 1].regressaoArr
    } else {
      regre = pontoCond.regressaoArr
    }
  }
  return regre
}

var fnPegaDataUTCNum = function (dataStr) {
  if (dataStr.indexOf('T') !== -1) {
    return Date.UTC.apply(undefined, dataStr.split('T')[0].split('-'))
  } else {
    return Date.UTC.apply(undefined, dataStr.split(' ')[0].split('-'))
  }
}

var fnTextoEntreTags = function(txt, tag) {
  var ini = txt.indexOf('<'+tag+'>')
  var fim = txt.indexOf('</'+tag+'>')
  var out = txt.slice(ini+tag.length+2, fim-2)
  return out
}

var fnFmtData = function(data, comTempo) {
  if (comTempo) {
    return moment(data).format('DD/MM/YYYY HH:mm:ss')
  } else {
    return moment(data).format('DD/MM/YYYY')
  }
}

var fnCampoValidoParaExibicao = function (val) {
  return val !== '-' && _.trim(val).length !== 0
}
var fnDescItem = function (item) {

  var arr = []

  if (fnCampoValidoParaExibicao(item.descricao)) arr.push('' + item.descricao)

  if (fnCampoValidoParaExibicao(item.fabricante)) arr.push('fabricante ' + item.fabricante)
  
  if (fnCampoValidoParaExibicao((item.modelo)) && !!item.modelo) arr.push('modelo ' + item.modelo)
  
  if (fnCampoValidoParaExibicao(item.identificacao)) arr.push('identificação ' + item.identificacao)
  
  if (fnCampoValidoParaExibicao(item.numeroserie)) arr.push('série n.: ' + item.numeroserie)

  if (fnCampoValidoParaExibicao(item.patrimonio)) arr.push('patrimônio ' + item.patrimonio)
  
  var txt = ''
  for (var i = 0; i < arr.length; i++) {
    if (i === arr.length - 1) {
      txt += ' e ' + arr[i]
    } else if (i === 0) {
      txt += '' + arr[i]
    } else {
      txt += ', ' + arr[i]
    }
  }
  var txt = txt.trim()
  //txt = txt.replace(/, (?![\s\S]*, )/, ' e ')
  return txt
}

var fnPegaStatus = function (dataUltimaCal, config) {
  const periodicidade = config.periodicidade
  const periodicidadeAlerta = config.periodicidadeAlerta

  const vencimentoM = moment(dataUltimaCal)
    .add(parseInt(periodicidade.val), periodicidade.suffixo)
  ;
  
  const periodicidadeDuration = moment
    .duration(parseInt(periodicidade.val), periodicidade.suffixo)
    .humanize()
  ;

  const periodicidadeStr = moment
    .duration(parseInt(periodicidade.val), periodicidade.suffixo)
    .humanize()
  ;

  const alertaM = moment(dataUltimaCal)
    .add(parseInt(periodicidade.val), periodicidade.suffixo)
    .subtract(periodicidadeAlerta.val, periodicidadeAlerta.suffixo)
  ;
  var dataProximaCal = vencimentoM.format('YYYY-MM-DD HH:mm:ss')

  var textoStatusVencimento
  const agoraM = moment()
  var cor = ''
  var situacao

  if (agoraM.isAfter(vencimentoM)) {
    textoStatusVencimento = 'venceu '
    situacao = 'VENCIDO'
    cor = 'is-danger'
  } else {
    
    if (agoraM.isAfter(alertaM)) {
      situacao = 'ALERTA_VENCIMENTO'
      cor = 'is-warning'
    } else {
      situacao = 'CALIBRADO'
      cor = 'is-success'
    }
    
    textoStatusVencimento = 'vence '
  }
  var texto = textoStatusVencimento + 
    agoraM.to(vencimentoM) + ' (' + vencimentoM.format('DD/MM/YYYY') + ')'
  ;

  if (config.periodicidade.status === 'Inativo') {
    situacao = 'INATIVO'
    cor = 'is-light'
  }

  if (config.periodicidade.status === 'Apoio') {
    situacao = 'APOIO'
    cor = 'is-link'
    texto = 'Instrumento de apoio'
  }


  return {
    texto: texto,
    textoCap: _.capitalize(texto),
    cor: cor,
    situacao: situacao,
    dataUltimaCal: dataUltimaCal,
    dataProximaCal: dataProximaCal
  }  
}

var fnPegaStatusChecagem = function (data) {
  if (data.length) {
    // A data da próxima checagem é definida a partir do parâmetro `dataDaProximaChecagem` definido
    // com o parâmetro `dataDaChecagem` na checagem cadastrada mais recente.
    var docsChecagemSorted = data.sort((a, b) => a.dataDaChecagem - b.dataDaChecagem);
    var ultimaChecagem = docsChecagemSorted[docsChecagemSorted.length -1];
    var dataDaProximaChecagem = ultimaChecagem.dataDaProximaChecagem;

    const agoraM = moment();
    const dataDaProximaChecagemM = moment.unix(parseInt(dataDaProximaChecagem/1000));
    const dataAlertaProximaChecagemM = moment.unix(parseInt(dataDaProximaChecagem/1000)).subtract(1, 'months');

    const proximoDoVencimento = agoraM.isAfter(dataAlertaProximaChecagemM);
    const venceu = agoraM.isAfter(dataDaProximaChecagemM);

    const delta = agoraM.to(dataDaProximaChecagemM);

    var texto = 'Checagem ' + (venceu ? 'venceu ' : ' ') + delta + ' ('+dataDaProximaChecagemM.format('DD/MM/YYYY')+')';

    var cor = 'is-success';
    var situacao = 'CALIBRADO';
    
    if (venceu) {
      cor = 'is-danger'
      situacao = 'VENCIDO'
    } else if (proximoDoVencimento) {
      cor = 'is-warning'
      situacao = 'ALERTA_VENCIMENTO'
    }

    return {
      texto: texto,
      cor: cor,
      data: dataDaProximaChecagemM,
      situacao: situacao,
      id: ultimaChecagem._id
    }
  }

  return undefined;
}

var fnQueryInstIdData = function (db) {
  var targetdb = db || INSTRUMENT_STORE.state.db

  var qparams = {
    startkey: [this.$route.params.id],
    endkey: [this.$route.params.id+'_\ufff0', 2],
    reduce: false // a parte do reduce sera executada no callback da query
  }
  console.log('Obtendo analises...')
  // TODO: Utilizar o allDocs para tornar a consulta mais rápida https://pouchdb.com/api.html#query_database
  //targetdb.allDocs({include_docs: true, startkey: this.$route.params.id, endkey: this.$route.params.id+'_\ufff0'}).then( (data) => {
  

  targetdb.query('analise/analise', qparams).then( (data) => {
    console.log('consulta do db realizada. Executando map/reduce...')
    var res = couchFnReduce(data)
    res.analise = {}
    INSTRUMENT_STORE.state.queryData = data['rows'][0]['value']['calibracoes'];
    INSTRUMENT_STORE.update(res);
    console.log('Pronto');

  }).catch( (err) => {
    // some error
    if (err.reason === 'missing') {
      console.warn('Utilizando analise remote')
      this.queryInstIdData(INSTRUMENT_STORE.remoteDB)
    } else {
      console.log(err)
      this.$router.push({ path: '/instrumentos' }).catch(err => {})
    }

  });
}


var fnConfigPeriodicidade = function (configPeriodicidadeResArr, AlPeriodoCalibracao, AlTipoPeriodo) {
  var configPeriodicidadeRes = configPeriodicidadeResArr[configPeriodicidadeResArr.length-1]

  var configPeriodicidade = {}

  if (!configPeriodicidadeRes) {

    // Usar periodicidade do autolab se nao existir registro criado pelo usuario
    if (AlPeriodoCalibracao) {

      const alSulfMap = {
        1: 1/30,  // dias
        0: 1/4,   // semanas
        3: 1,     // meses
        2: 12     // anos
      }
      
      var meses = alSulfMap[AlTipoPeriodo] * AlPeriodoCalibracao

      configPeriodicidade = {
        periodicidade: {val: meses, suffixo: 'months'} // Utilizar meses
      }


    // Se nao tiver no autolab tb, utilizar um padrao
    } else {

      configPeriodicidade = {
        periodicidade: {val: 12, suffixo: 'months'} // Utilizar meses
      }

    }

  } else {
    configPeriodicidade.periodicidade = configPeriodicidadeRes.periodicidade
    configPeriodicidade.periodicidadeAlerta = configPeriodicidadeRes.periodicidadeAlerta
    
    configPeriodicidade.localizacao = configPeriodicidadeRes.localizacao
    configPeriodicidade.tecnicoResponsavel = configPeriodicidadeRes.tecnicoResponsavel
  }

  // A periodicidade de alerta hoje não pode ser definida na UI.
  // Estamos definindo aqui uma periodicidade padrão
  configPeriodicidade.periodicidadeAlerta = configPeriodicidade.periodicidadeAlerta || {
    val: 2, suffixo: 'months'
  }
  return configPeriodicidade
}

const faixaKeys = 'CodigoFaixaModelo Unidade DescFaixa Prefixo FreqPrefixo Freq'.split(' ')
const serieKeys = 'nome cod sortval'.split(' ')
const valKeys = 'IncertExpandidaUsada ResultadoMedicao ErroMinimoFaixa ValorDoPadrao ValorDoInstrumento ErroMaximoFaixa Valor fatork'.split(' ')
const CAMPOS = faixaKeys.concat(serieKeys).concat(valKeys)

const calDataToCsv = function (data) {
  let res = ''
  data.map((faixa) => {
    faixa.series.map((serie) => {
      serie.data.Valor.map((_val, i) => {
        let line = ''
        faixaKeys.map((k) => line += `${faixa[k]};`)
        serieKeys.map((k) => line += `${serie[k]};`)
        valKeys.map((k) => line += `${serie.data[k][i]};`)
        res += line.trim()+'\n'
      })
    })
  })
  return res
}


const calCsvToJSON = function (csv) {

  // verifica se arquivo tem cabecalho
  // e remove caso verdadeiro

  let primeiraLinha = csv.split('\n')[0].split(';')

  let cabecalho
  if ((primeiraLinha.indexOf('CodigoFaixaModelo') !== -1) && (primeiraLinha.indexOf('DescFaixa') !== -1)) {
    csv = csv.split('\n').slice(1).join('\n')
    cabecalho = primeiraLinha
  }


  let indices = (cabecalho || CAMPOS).reduce((a, c, i) => {
    a[c] = i
    return a
  }, {})
  
  let fIDi = CAMPOS.indexOf('CodigoFaixaModelo')
  let sIDi = CAMPOS.indexOf('cod')
  
  let matrix = csv.trim().split('\n').map((line) => line.split(';'))

  let faixas = []
  matrix.map(linha => {
    
    let faixa
    let buscaFaixa = faixas.filter(f => f.CodigoFaixaModelo === linha[fIDi])
    if (!buscaFaixa.length) {
      faixa = {}
      faixaKeys.map((key) => {
        faixa[key] = linha[indices[key]]
      })
      faixa.series = []
      faixas.push(faixa)
    } else {
      faixa = buscaFaixa[0]
    }

    let buscaSerie = faixa.series.filter(s => s.cod === linha[sIDi])
    let serie
    if (!buscaSerie.length) {
      serie = {
        data: {}
      }
      
      serieKeys.map((key) => {
        serie[key] = linha[indices[key]]
      })
      
      valKeys.map(key => {
        serie.data[key] = []
      })
      
      faixa.series.push(serie)
    } else {
      serie = buscaSerie[0]
    }
    
    valKeys.map((key) => {
      let val = parseFloat(linha[indices[key]])
      serie.data[key].push(val)
    })
  })
  return faixas
}

const fnSetLoggedOut = function () {
  window.localStorage.removeItem('nomedb')
  window.localStorage.removeItem('userCtx')

  var el = document.getElementById('pdf-container')
  el.style.display = 'none'

  INSTRUMENT_STORE.state.db = null
  
  if (!INSTRUMENT_STORE.remoteDB) return
  
  INSTRUMENT_STORE.remoteDB.logOut( (err, response) => {
    if (err) {
      console.log(err)
    }
    /*if (response && response.ok) {

    }*/
  })      
}


export {fnSignformatter,
fnHideOnClickOutside,
fnRegreArray,
fnPegaDataUTCNum,
fnTextoEntreTags,
fnFmtData,
fnCampoValidoParaExibicao,
fnDescItem,
fnPegaStatus,
fnPegaStatusChecagem,
fnQueryInstIdData,
fnConfigPeriodicidade,
calDataToCsv,
calCsvToJSON,
CAMPOS,
fnSetLoggedOut}